import {
    CONFIRMED_CREATE_PRODUCT_REQUEST_ACTION,
    CONFIRMED_DELETE_PRODUCT_REQUEST_ACTION,
    CONFIRMED_EDIT_PRODUCT_REQUEST_ACTION,
    CONFIRMED_GET_PRODUCT_REQUESTS,
    CREATE_PRODUCT_REQUEST_ACTION,    
    CREATE_PRODUCT_REQUEST_ERROR_ACTION,
    CLEAR_PRODUCT_REQUEST_ERROR,
    LOADING_PRODUCT_REQUESTS    
} from '../actions/ProductRequestTypes';

const initialState = {
    productRequests: [],
    loading: false,
    createProductRequestError: {}
};

export default function ProductRequestReducer(state = initialState, actions) {
    if (actions.type === CREATE_PRODUCT_REQUEST_ACTION) { 
        return {
            ...state,
            productRequests: [...state.productRequests],
        };
    }

    if (actions.type === CONFIRMED_DELETE_PRODUCT_REQUEST_ACTION) {
        const productRequests = state.productRequests.filter(productRequest => productRequest.id !== actions.payload);
        return {
            ...state,
            productRequests,
        };
    }

    if (actions.type === CONFIRMED_EDIT_PRODUCT_REQUEST_ACTION) {
        const productRequests = state.productRequests.map(productRequest => 
            productRequest.id === actions.payload.id ? actions.payload : productRequest
        );
        return {
            ...state,
            productRequests,
        };
    }

    if (actions.type === CONFIRMED_CREATE_PRODUCT_REQUEST_ACTION) {
        return {
            ...state,
            productRequests: [...state.productRequests, actions.payload],
        };
    }

    if (actions.type === CONFIRMED_GET_PRODUCT_REQUESTS) {
        return {
            ...state,
            productRequests: actions.payload,
        };
    }

    if (actions.type === LOADING_PRODUCT_REQUESTS) {
        return {
            ...state,
            loading: actions.payload,
        };
    }

    if (actions.type === CREATE_PRODUCT_REQUEST_ERROR_ACTION) {
        return {
            ...state,
            createProductRequestError: actions.payload,
        };
    }

    if (actions.type === CLEAR_PRODUCT_REQUEST_ERROR) {
        return {
            ...state,
            createProductRequestError: {},
        };
    }
  
    return state;
}
